module.exports = __webpack_public_path__ + "static/media/jana.ffa18048.jpg";